var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fix-padding" }, [
    _c("iframe", {
      ref: "embed",
      style:
        "width: 100%; min-height: calc(100vh - " +
        (_vm.mobile ? 50 : 70) +
        "px)",
      attrs: { src: _vm.path },
      on: { load: _vm.embedLoad },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }